<template>
  <a class="c-btn c-btn--blue u-w250" href="#">
    <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <use xlink:href="/assets/img/sprite.svg#edit" />
      </svg>
    </div>
    <p class="c-btn__text">配信メッセージの作成</p>
  </a>
</template>